import { PostAnywayFilterFeature } from 'feature/moddash/post-anyway-filter';
import { component, demoFile } from 'system/demo';

function FilterExample() {
    const filter = PostAnywayFilterFeature.providesConfig!.modFilters![0].filter as (item: any) => boolean;
    const items = [
        {key: 1, object: {minorViolation: true}},
        {key: 2, object: {minorViolation: false}}
    ];
    const filtered = items.filter(filter);
    return <pre>{JSON.stringify(filtered)}</pre>;
}

demoFile('feature/moddash/post-anyway-filter');

component('FilterExample', FilterExample);
